export const PAGE_VIEW = {
  PV: "pageview.wxshop.pv", //html的pv
  HOME_PAGE: "pageview.wxshop.homepage", //首页曝光
  AUTH: "pageview.wxshop.privacy", // 隐私协议曝光
  AUTH_MANAGE: "pageview.wxshop.zq_authorize", //专区授权管理页面曝光

  INDEX_BANNER_PAGE: "pageview.wxshop.indexbanner", //首页广告曝光
  INDEX_RECOMMEND: "pageview.wxshop.indexrecommend", //首页推荐曝光
  SERVICE_LIST: "pageview.wxshop.service_list", //列表页曝光
  NAV_SERVICE_LIST: "pageview.wxshop.nav_service_list", //带导航的列表页曝光

  CHOSE_COUPON: "pageview.wxshop.chosecoupon", //选择优惠券弹窗曝光
  COUPON_ENTRY: "pageview.wxshop.zq_goods_detail_coupon", //商品详情页-选择抵扣券曝光（有券）

  ORDER_PAGE: "pageview.wxshop.orderpage", //订单页曝光
  ORDER_PAGE_NEW: "pageview.wxshop.orderpage_v1", //订单页曝光abtest

  ORDER_BANNER_PAGE: "pageview.wxshop.orderbanner", //档位广告曝光
  ORDER_BANNER_PAGE_NEW: "pageview.wxshop.orderbanner_v1", //档位广告曝光

  PERSONAL_PAGE: "pageview.wxshop.personal", //个人中心页曝光

  RESULT_BANNER_PAGE: "pageview.wxshop.resultbanner", //结果页广告曝光
  RESULT_PAGE: "pageview.wxshop.result", //支付结果页曝光
  ZQ_RESULT_PAGE: "pageview.wxshop.zq_result", //支付结果页曝光
  QB_RESULT_QRCODE: "pageview.wxshop.resultqrcode", //支付结果页出现关注微信公众号二维码的曝光
  WELCOME_PAGE: "pageview.wxshop.new", //欢迎页曝光
  SERVICE_LIST_ADS: "pageview.wxshop.service_list_ads",
  IP_ZONE_RESULT_RECOMMEND_ADS: "pageview.wxshop.resultpage_ipzone_resultads",
  RESULT_ANCHOR_FULI: "pageview.wxshop.zq_result_fuli", //结果页获取主播福利曝光
  RESULT_APP_BACK: "pageview.wxshop.zq_result_back", //结果页返回快手app曝光
  RESULT_QQ_DY: "pageview.wxshop.result_dy", //结果页QQ订阅弹窗曝光

  RISK_CONTROL_PAGE: "pageview.wxshop.qb_risk", //风控曝光
  RISK_CONTROL_SUCCESS: "pageview.wxshop.qb_ok", //风控验证成功

  // 登录弹窗
  LOGIN_DIALOG_PAGE: "pageview.wxshop.login_dialog", // 登录弹窗曝光

  //取推荐接口历史充值号码成功
  RECOMMEND_DEFAULT_QQ: "pageview.wxshop.recommend_default_qq",
  //取推荐接口历史充值号码异常
  RECOMMEND_DEFAULT_QQ_FAILURE: "pageview.wxshop.recommend_default_qq_failure",
  //用户腾讯视频推荐数据上报
  USER_TXSP_RECOMMEND: "success.wxshop.txspipzone_vip_hit",

  QB_HELPPAY_PAGE: "pageview.askpage", //qb索要页面
  UNDEFINED_BIZ: "pageview.wxshop.undefined.business",
  TXSP_7DASY_ACTIVITY: "pageview.1r7day.home",

  TXSP_10R_CMONTH: "pageview.txsp10rcomonth.home", //  拍脸图曝光
  TXSP_10R_WIDGET: "pageview.txsppendant.home", // 挂件曝光

  QB_PLUS_TXSP_SUCCESS: "pageview.wxshop.qb_vip.success", //购买QB+视频成功
  QB_PLUS_TXSP_ERROR: "pageview.wxshop.qb_vip.error", //购买QB+视频报错
  QB_PLUS_NO_DRM_QUALIFICATION: "pageview.wxshop.qb_vip.has_no_drm_qualification", //用户查无活动资格
  QB_PLUST_DRM_QUALIFICATION_FAILURE: "pageview.wxshop.qb_vip.get_drm_qualification_failure", //查用户有无资格请求异常
  PRODUCT_CONFIG_ERROR: "pageview.wxshop.product_config_error", //商品配置信息有误
  MOBILE_ZONE_ROLE: "pageview.wxshop.mobile_zone_role", //查询手游角色信息
  MOBILE_ZONE_LIST: "pageview.wxshop.mobile_zone_list", // 手游大区列表
  IOS_WHITE_LIST: "pageview.wxshop.ios_whitelist", // ios白名单查询曝光
  IOS_POPS_DISABLE: "pageview.wxshop.ios_whitelist_disable_popups", // ios 弹窗拦截
  IOS_WHITE_SUCCESS: "pageview.wxshop.ios_whitelist_success", // ios 白名单成功上报

  GAME_LIST_AREA: "pageview.wxshop.game_list_area", // 商店二级页面，王者荣耀专区页面曝光

  IPZONE_PAGESHOW: "pageview.wxshop.ipzone_page", // 商店视频专区页面曝光
  VIPLIST_IPZONE_PAGESHOW: "pageview.wxshop.vipipzone_page", // 商店视频专区页面曝光
  ERROR_PAGE: "pageview.wxshop.error", // 商店统一错误页面曝光
  ADS_PAGE: "pageview.wxshop.ads", // 商店广告页面曝光

  SERVICEZONE_INDEX: "pageview.wxshop.zq_homepage", // 专区首页曝光（名称-综合）
  SERVICEZONE_POPUP_CUSTON: "pageview.wxshop.zq_popup_custom", // 自定义充值金额-弹窗
  SERVICEZONE_RECOMMEND: "pageview.wxshop.zq_recommend", // 综合推荐频道
  SERVICEZONE_CUSTOM: "pageview.wxshop.zq_custom", // 自定义频道
  SERVICEZONE_GOODS: "pageview.wxshop.zq_goods", // 全量商品频道（名称-全部道具）
  SERVICEZONE_GOODS_DRAWER: "pageview.wxshop.zq_goods_drawer", // 道具抽屉
  SERVICEZONE_RANK_LIST: "pageview.wxshop.zq_ranking", // 特性榜单频道（名称-特性榜单）
  SERVICEZONE_RANK_DETAIL: "pageview.wxshop.zq_ranking_detail", // 特性榜单详情页
  SERVICEZONE_NEWS: "pageview.wxshop.zq_content", // 资讯频道（名称-资讯）
  SERVICEZONE_NEWS_LIST_SINGLE: "pageview.wxshop.zq_content_single", //资讯频道-单个资讯曝光
  SERVICEZONE_NEWS_SHELF_SINGLE: "pageview.wxshop.zq_shelf_content", //综合频道-资讯模块单个资讯曝光
  SERVICEZONE_NEWS_DETAIL: "pageview.wxshop.zq_content_detail", // 资讯内容页详情页
  SERVICEZONE_NEWS_NOFOUND: "pageview.wxshop.zq_content_detail_nofound", // 道具资讯页未找到
  SERVICEZONE_SEARCH: "pageview.wxshop.zq_search", // 搜索页面曝光
  SERVICEZONE_HOT: "pageview.wxshop.zq_hot", // 热门商品频道（名称-热门）
  SERVICEZONE_NEW: "pageview.wxshop.zq_new", // 新品频道（名称-新品）
  SERVICEZONE_CLASSIFYLIST: "pageview.wxshop.zq_classifyList", // 分类货架
  SERVICEZONE_SHELF_GOODS_RECOMM: "pagview.wxshop.zq_shelf_goods_recomm", // 首页精选推荐货架
  SERVICEZONE_SHELF_GOODS_ACTIVITY: "pageview.wxshop.zq_shelf_goods_activity", // 首页限时活动货架
  SERVICEZONE_HIGHSCORE: "pageview.wxshop.zq_highscore", // 高分货架
  SERVICEZONE_DOMMODITY: "pageview.wxshop.zq_commodity", //商品频道-货架曝光（新版）
  SERVICEZONE_PAGEDOO_BUY_SEND_QUERY_ERROR: "pageview.wxshop.zq_pagedoo_buy_send_error",

  // 道具详情页相关上报
  SERVICEZONE_GOODS_DETAIL: "pageview.wxshop.zq_goods_detail", // 商品详情&订单页
  SERVICEZONE_GOODS_DETAIL_CARD: "pageview.wxshop.zq_goods_detail_card", // 商品详情&订单页
  SERVICEZONE_GOODS_DETAIL_PIC: "pageview.wxshop.zq_goods_detail_pic", // 详情页- 头图横滑曝光

  // 详情页好友推荐
  DETAIL_FRIEND_RECOMMEND: "pageview.wxshop.zq_goods_detail_friend", //商品详情页好友推荐条曝光
  DETAIL_RATE_FRIEND_RECOMMEND: "pageview.wxshop.zq_score_result_friend", //评分后引导弹窗推荐条曝光
  DETAIL_FRIEND_RECOMMEND_DIALOG: "pageview.wxshop.zq_friend", //好友推荐弹窗曝光
  DETAIL_FRIEND_RECOMMEND_DIALOG_POS: "pageview.wxshop.zq_friend_position", //好友推荐弹窗好友推荐信息曝光

  RESULT_FRIEND_RECOMMEND: "pageview.wxshop.zq_recommend_friend", //支付结果页推荐条曝光
  RESULT_FRIEND_RECOMMEND_RATE: "pageview.wxshop.zq_score_friend", //支付结果页推荐条曝光

  PREORDER_INDEX: "pageview.wxshop.zq_pre", // 游戏币预售页曝光
  PREORDER_DAOJU_INDEX: "click.wxshop.dj_pre", // 道具预售页曝光

  RESERVATION_INDEX: "pageview.wxshop.zq_reservation", // 预约页曝光

  PAGEVIEW_PREFIX: "pageview.wxshop.", //前缀

  // 月卡专区配置
  GAME_MONTHCARD_INDEX: "pageview.wxshop.monthcard_homepage", // 专区月卡页面曝光
  GAME_MONTHCARD_DETAIL_INIT_ERROR: "pageview.wxshop.monthcard_detail_init_error", // 专区月卡页面，未找到月卡配置
  GAME_MONTHCARD_DETAIN_PROMPT: "pageview.wxshop.monthcard_datain_prompt", // 游戏月卡页面挽留弹窗曝光
  GAME_MONTHCARD_SHELF_SHOW: "pageview.wxshop.monthcard_shelf_show", // 游戏月卡出现上报

  SERVICE_ZONE_POP_SHOW: "pageview.wxshop.zq_pop_show", // 专区首页拍脸弹窗曝光
  SERVICE_ZONE_POP_SUCCESS: "pageview.wxshop.zq_pop_receive_success", // 专区首页拍脸弹窗，领取成功
  SERVICE_ZONE_POP_LIMIT: "pageview.wxshop.zq_pop_receive_limit", // 专区首页拍脸弹窗，领取限次
  SERVICE_ZONE_POP_ERROR: "pageview.wxshop.zq_pop_receive_error", // 专区首页拍脸弹窗报错
  PENDANT_SHOW: "pageview.wxshop.pendant_show", // 挂件曝光

  //分销活动相关
  GET_TASK_PROGRESS_SUCC: "pageview.wxshop.fenxiao.shop_info_success",
  GET_TASK_PROGRESS_ERROR: "pageview.wxshop.fenxiao.shop_info_error",

  TASK_CENTER_SHOW: "pageview.wxshop.zq_mission", // 任务中心曝光
  TASK_CENTER_SHOW_ERR: "pageview.wxshop.zq_mission_err", // 任务中心渲染报错
  GET_TASK_PRESENT: "pageview.wxshop.zq_popup_mission", // 任务中心领取成功弹窗
  GET_TASK_PRESENT_NOROLE: "pageview.wxshop.zq_mission_norole_err", // 任务中心没有选择大区
  GET_TASK_PRESENT_ERR: "pageview.wxshop.zq_popup_mission_err", // 任务中心领取失败弹窗
  //专区推荐接口请求成功或失败
  GET_IPZONE_RECOMMEND_SUCCESS: "pageview.wxshop.get_ipzone_recommend_success",
  GET_IPZONE_RECOMMEND_FAILURE: "pageview.wxshop.get_ipzone_recommend_failure",
  GET_IPZONE_RECOMMEND_AND_FILE_FAILURE: "pageview.wxshop.get_ipzone_recommend_and_file_failure",
  GET_IPZONE_RECOMMEND_FILE_FAILURE: "pageview.wxshop.get_ipzone_recommend_file_failure",
  GET_IPZONE_RECOMMEND_SURROUNDING_FAILURE: "pageview.wxshop.get_ipzone_recommend_surrounding_failure",
  GET_IPZONE_RECOMMEND_READER_FAILURE: "pageview.wxshop.get_ipzone_recommend_reader_failure",

  // 集市及广场曝光
  MALL_SHOW: "pageview.wxshop.mall",
  MALL_GOODS_SHOW: "pageview.wxshop.mall_position", //resultinfo传商品id和坑位，顺序坑位格式：1、2、3...从左往右从上到下；
  MALLSHOP_SHOW: "pageview.wxshop.mallshop",
  MALLSHOP_ZONE_SHOW: "pageview.wxshop.mallshop_zone", //resultinfo传专区offerid和坑位，顺序坑位格式：1、2、3...从上到下；
  CONTENT_DETAIL: "pageview.wxshop.content", // 内容详情页的曝光
  MALL_CONTENT_QUIT: "pageview.wxshop.content_quit", // 退出详情页时的上报, resultInfo内传入内容的观看完整度等内容

  MALL_CONTENT_RELATED: "pageview.wxshop.content_related", // 内容详情页推荐内容曝光

  MALL_READ_TASK_COMPLETE_SHOW: "pageview.wxshop.mall_floating_finish",
  MALL_READ_TASK_SHOW: "pageview.wxshop.mall_floating",

  // 新游预约集合页
  RESERVATION_LIST_SHOW: "pageview.wxshop.reservation_collectionpage",

  // 游戏列表页
  GAME_ZONE_LIST_SHOW: "pageview.wxshop.game_collectionpage",
  INDEX_ROUTE: "pageview.wxshop.index_route", // index 路由曝光时的上报

  // 直播购相关页面
  LIVE_SQUERE_SHOW: "pageview.wxshop.livesquare",
  LIVE_SQUERE_MALL_SHOW: "pageview.wxshop.livemall",
  LIVE_LIST_SHOW: "pageview.wxshop.livepage",
  LIVE_DETAIL_SHOW: "pageview.wxshop.liveroom",
  LIVE_PRODUCT_USING_SHOW: "pageview.wxshop.liveroom_using",
  LIVE_PRODUCT_RECOMMEND_SHOW: "pageview.wxshop.liveroom_recommend",

  // 道具通兑页
  REDEEM_HOMEPAGE_SHOW: "pageview.wxshop_exchange.homepage_show", // 曝光-兑换页
  REDEEM_HOMEPAGE_NOT_EXCHANGE: "pageview.wxshop_exchange.homepage", // 曝光-兑换页-没兑换
  REDEEM_HOMEPAGE_EMPTY: "pageview.wxshop_exchange.homepage_empty", // 曝光-兑换页-没券
  REDEEM_HOMEPAGE_DONE: "pageview.wxshop_exchange.homepage_done", // 曝光-兑换页-已兑换
  REDEEM_PRODUCT_LIST_EMPTY: "pageview.wxshop_exchange.redeem_product_empty", // 曝光-兑换页-已兑换

  DETAIL_OUTER_CHANGE_ACCOUNT: "pageview.wxshop.zq_account", // 商品详情页，qq/微信弹窗曝光
  DETAIL_BUY_POPUPS: "pageview.wxshop.zq_buy_popups", // 商品详情页，购买提示弹窗 || 即购买前二次确认弹窗

  IPZONE_GOODS_DETAIL: "pageview.wxshop.txspipzone_coupon_detail", //（resultinfo里传：券类型 and 券id）观影券曝光
  IPZONE_GOODS_NOVIP_TIP: "pageview.wxshop.txspipzone_coupon_detail_popups", //点播券页面-非会员购买提示曝光
  IPZONE_GOODS_VIP_TIP: "pageview.wxshop.txspipzone_coupon_film_popups_vip", //观影券页-会员按非会员价购买提示曝光
  IPZONE_GOODS_BUY_ALREADY: "pageview.wxshop.txspipzone_coupon_film_popups_already", //观影券页-已购买过提示曝光,

  // 二楼
  SECOND_FLOOR_SHOW_IMEDIATELY: "pageview.wxshop.homepage_openbanner", // 首页开屏广告曝光
  SECOND_FLOOR_SHOW_ITEM: "pageview.wxshop.indexbanner_head", // 首页-二楼广告图曝光，改版新增，resultinfo传位置和素材id

  // 评星
  STAR_RATE_DIALOG_SHOW: "pageview.wxshop.zq_score_pop", // 评星弹窗曝光
  STAR_RATE_VIEW_SHOW: "pageview.wxshop.zq_score_view", // 评星弹窗曝光
  STAR_RATE_NOT_QUALIFIED: "pageview.wxshop.zq_score_condition_pop", // 评分资格判断弹窗曝光
  DETAIL_DIMENSION_LACK: "pageview.wxshop.zq_score_dimension_lack", // 评分维度不足toast提示曝光
  DETAIL_RATE_NOT_CHANGED: "pageview.wxshop.zq_score_dimension_not_changed", // 评分用户未修改，点提交
  DETAIL_RATE_RESULT_POP: "pageview.wxshop.zq_score_result_pop", // 评分后引导弹窗曝光
  DETAIL_RESULT_POP_ERROR: "pageview.wxshop.zq_score_result_pop_error", // 评分后引导弹窗返回点击

  // 发电榜
  IPZONE_CHARTS_NAV: "pageview.wxshop.txspipzone_charts", //发电榜tab

  // 团购相关
  DETAIL_TEAM_HOMEPAGE_NOTEAM: "pageview.wxshop.zq_act_team_homepage_before", //活动组件首页曝光（参团前）
  DETAIL_TEAM_HOMEPAGE_OTHER: "pageview.wxshop.zq_act_team_homepage_join", //活动组件首页曝光（分享进入/点击参与别人团）
  DETAIL_TEAM_HOMEPAGE_SELF: "pageview.wxshop.zq_act_team_homepage_self", //活动组件首页曝光（分享进入/点击参与别人团）
  DETAIL_TEAM_RULE_POP: "pageview.wxshop.zq_act_team_popup_rule", //活动组件活动规则弹窗曝光
  DETAIL_TEAM_PAY_SUCC: "pageview.wxshop.zq_act_team_popup_paysuccess", //活动组件支付成功弹窗曝光
  DETAIL_TEAM_SHARE: "pageview.wxshop.zq_act_team_popup_share", //活动支付成功分享卡曝光（支付成功后）
  DETAIL_TEAM_STRANGER_LIST: "pageview.wxshop.zq_act_team_popup_list", //活动组件陌生人团页曝光
  DETAIL_FISSION_PROCESS: "pageview.wxshop.zq_goods_detail_enter_fission_process", //详情页配置了裂变活动，支付完进入裂变环节
  DETAIL_FISSION_EMPTY: "pageview.wxshop.zq_goods_detail_empty_fission_coupon", //买赠时，赠的券未查询到时弹窗曝光
  DETAIL_FISSION_POSTER: "pageview.wxshop.zq_goods_detail_fission_poster", //详情页裂变海报分享

  FRIENDPAY_POSTER: "pageview.wxshop.friendpay_poster", //游戏币或道具好友索要海报曝光

  TAB_AB_TEST: "pageview.wxshop.abtest", // ab实验曝光

  // 订单中心相关
  ORDERS_ENTRANCE_SHOW: "pageview.wxshop.orderscenter", // 订单中心页面曝光埋点上报

  // 背包相关
  BACKPACK: "pageview.wxshop.zq_backpack", // 背包列表页曝光
  BACKPACK_DETAIL: "pageview.wxshop.zq_backpack_detail", // 背包详情页曝光
  BACKPACK_FILTER: "pageview.wxshop.zq_backpack_filter_popup", // 背包筛选器曝光
  BACKPACK_INVENTORY_LIST: "pageview.wxshop.zq_backpack_collection", // 背包集合页页面曝光
  BACKPACK_INVENTORY_DETAIL: "pageview.wxshop.zq_backpack_singleseries", // 系列详情页曝光（区分系列，可依据系列的id）
  BACKPACK_NEW_YEAR_FULL: "pageview.wxshop.zq_backpack_singleseries_unlocked", // 所有道具均解锁状态下的页面曝光

  // 第三方登录态绑定相关
  BIND_BEORNOT_POPUPS: "pageview.wxshop.zq_bind",
  BIND_ACCOUNT_POPUPS: "pageview.wxshop.zq_bind_popups",

  // 详情页赠送-选择好友弹窗
  SEND_SELECT_FRIEND_POPUP: "pageview.wxshop.zq_goods_selectfriend_popups"
}

export const CLICK = {
  //点击个人中心
  PERSONAL_ENTRANCE: "click.wxshop.personal",
  //首页BANNER
  INDEX_BANNER: "click.wxshop.banner",
  //首页导航点击
  NAV_TAB: "click.wxshop.nav",
  //欢迎页点击开启充值之旅
  INDEX_WELCOME_TOUR: "click.wxshop.new",
  //QB充值修改QQ号码
  CHANGE_PROVIDEUIN: "click.wxshop.qb_change",
  //qb其他数额
  QB_OTHER_AMOUNT: "click.wxshop.qb_other",
  //使用优惠券
  QB_COUPON: "click.wxshop.qb_coupon",
  //QB充值按钮
  QB_RECHARGE: "click.wxshop.qb_button",
  QB_OPEN_WECHAT_PAY: "click.wxshop.qb_open_wechat_pay",
  //查看更多业务
  MORE_BUSINESS: "click.wxshop.common_more",
  //首页推荐业务1
  WECHAT_RECOMMEND_BUSINESS: "click.wxshop.common", //四个位置分别为click.wxshop.common1,click.wxshop.common2，click.wxshop.common3，click.wxshop.common4
  //订单页切换帐号
  CHANGE_ACCOUNT: "click.wxshop.orderpage_change",
  //订单页点击编辑QQ号按钮
  CHANGE_ORDER_PROVIDEUIN: "click.wxshop.orderpage_rewrite",
  //订单页点击充值按钮
  ORDER_RECHARGE: "click.wxshop.orderpage_button",
  //订单页banner广告点击
  ORDER_BANNER: "click.wxshop.orderpage_banner",
  ORDER_DAOJU: "click.wxshop.orderpage_daoju",
  //自定义输入框点击
  ORDER_CUSTOM_AMOUNT: "click.wxshop.orderpage_custom",
  //订单页右上角商品点击弹出下拉框
  // ORDER_DROPDOWNLIST_PRODUCT: "click.wxshop.orderpage_or",
  //订单也右上角商品点击切换商品
  // ORDER_DROPDOWNLIST_PRODUCT_SWITCH: "click.wxshop.orderpage_or_confirm",

  // 结果页
  //支付结果页的返回首页
  RESULT_RETURN_INDEX: "click.wxshop.result_homepage",
  // 支付结果页关闭
  RESULT_RETURN_CLOSE: "click.wxshop.result_close",
  //支付结果页点击广告
  RESULT_CLICK_ADS: "click.wxshop.result_ad",
  //支付结果页小黄条点击广告
  RESULT_CLICK_NOTE_ADS: "click.wxshop.result_score",
  //支付结果页点击积分兑换
  RESULT_CLICK_JF: "click.wxshop.result_jf",
  //支付结果页点击订阅
  RESULT_CLICK_DY: "click.wxshop.result_dy",
  //支付结果页点击取消订阅
  RESULT_CLICK_CANCELDY: "click.wxshop.result_canceldy",
  //支付结果页提醒好友领取-按钮点击
  RESULT_CLICK_SEND_RECEIVE: "click.wxshop.zq_result_remind",

  // 搜素
  // 点击搜索输入框
  SEARCH_INPUT_FOCUS: "click.wxshop.search_insert",
  // 首页搜索关键词点击
  SEARCH_INPUT_RESULT: "click.wxshop.search_insert_result",
  // 专区搜索关键词点击
  SERVICEZONE_SEARCH_RESULT: "click.wxshop.zq_search_result",
  // 搜索热词
  SEARCH_HOT: "click.wxshop.search_hot",
  // 搜索历史记录
  SEARCH_HIS: "click.wxshop.search_his",
  // 搜索推荐词
  SEARCH_ASSOCIATE: "click.wxshop.search_associate",
  // 取消搜索
  CANCEL_SEARCH: "click.wxshop.search_can",
  // 清空用户输入
  CLEAR_SEARCH_INPUT: "click.wxshop.search_clear",
  // 清空历史记录
  CLEAR_HIS_SEARCH: "click.wxshop.clear_his_search",
  // 你是不是想搜
  SEARCH_MORE: "click.wxshop.search_more",
  // 列表页 任一已区域点击
  SERVICE_LIST: "click.wxshop.item.service_list",
  // 列表页游戏福利专区
  SERVICE_LIST_GAME_WELFARE: "click.wxshop.service_list.game.welfare",
  // 积分福利专区
  SERVICE_LIST_GAME_JIFEN: "click.wxshop.service_list.game.jifen",
  // 积分新游福利社
  SERVICE_LIST_GAME_SWIPER: "click.wxshop.service_list.game.swiper",
  // 列表页广告点击
  SERVICE_LIST_ADS: "click.wxshop.item.service_list_ads",
  //一键预约
  MAKE_PRODUCT_APPOINTMENT: "click.wxshop.search_appoint",
  // 搜索字母索引上报
  USER_TOUCH_LETTERS: "click.wxshop.letter.service_list",
  /*柔性风控相关*/
  //关闭风控
  RISK_CONTROL_CLOSE: "click.wxshop.qb_risk_close",
  /* 订单页abtest */
  //订单页切换帐号
  CHANGE_ACCOUNT_NEW: "click.wxshop.orderpage_change_v1",
  //订单页点击编辑QQ号按钮
  CHANGE_ORDER_PROVIDEUIN_NEW: "click.wxshop.orderpage_rewrite_v1",
  //订单页点击充值按钮
  ORDER_RECHARGE_NEW: "click.wxshop.orderpage_paybutton_v1",
  //订单页banner广告点击
  ORDER_BANNER_NEW: "click.wxshop.orderpage_banner_v1",
  //自定义输入框点击
  ORDER_CUSTOM_AMOUNT_NEW: "click.wxshop.orderpage_custom_v1",
  //档位选择
  ORDER_AMOUNT_CHOOSE_NEW: "click.wxshop.orderpage_choose_v1",
  /* QB代付页 */
  //自己支付点击
  ASKPAGE_PAY_MYSELF: "click.askpage_pay_myself",
  //慷慨支付点击
  ASKPAGE_PAY_ANOTHER: "click.askpage_pay_another",
  TXSP_7DAYS_POPUP: "click.1r7day.home",

  TXSP_10R_WIDGET: "click.txsppendant.home", //挂件点击
  TXSP_10R_ADS: "click.txsp10rcomonth.home", //拍脸图点击,

  QB_PLUS_TXSP_SHOW: "click.wxshop.qb_qbsvip", //首页Q币+视频点拉起
  QB_PLUS_TXSP_SELECTED: "click.wxshop.qb_qbsvip_selected", //qb+档位选中
  QB_PLUS_TXSP_BUY: "click.wxshop.qb_qbsvip_button", //浮层的点击按钮
  QB_PLUS_TXSP_MORE_EXPAND: "click.wxhsop.qb_qbsvip_more", //点击展开更多QB+套餐
  QB_PLUS_TXSP_ORIGINAL_PRICE: "click.wxshop.qb_qbsvip_original_price", //用户无活动资格，原价购买

  GAMECOIN_PLUS_SELECT: "click.wxshop.gamecoin_plus_select", // 选中游戏币绑定包月档位
  GAMECOIN_PLUS_PAY: "click.wxshop.gamecoin_plus_pay", // 游戏币绑定包月档位-点击支付

  // 登录弹窗
  LOGIN_DIALOG_SHOW: "click.wxshop.show_login_dialog", // 打开登录弹窗
  LOGIN_DIALOG_CLOSE: "click.wxshop.close_login_dialog", // 关闭登录弹窗
  AUTH_ACCEPT: "click.wxshop.privacy_agree", // 用户同意授权
  AUTH_REFUSE: "click.wxshop.privacy_refuse", // 用户拒绝授权

  // 王者荣耀专区
  GAME_LIST_WZ_AREA: "click.wxshop.wz_area", // 点击头部进入专区
  GAME_LIST_WZ_LOGO: "click.wxshop.wz_catalogue_logo", // 点击头部logo进入专区
  GAME_LIST_WZ_DQCZ: "click.wxshop.wz_dqcz", // 点击点券充值
  GAME_LIST_WZ_MORE: "click.wxshop.wz_more", // 点击英雄皮肤区—更多
  GAME_LIST_WZ_RECOMMEND: "click.wxshop.wz_recommend", // 点击英雄皮肤区—道具（多个道具从1开始递增，如wz_recommend1， wz_recommend2...）

  RESULT_CLICK_RECOMM_MORE: "click.wxshop.result_recomm_more", // 点击结果页更多
  RESULT_CLICK_RECOMM_DETAIL: "click.wxshop.wz_recomm_detail", // 点击结果页推荐道具（多个道具从1开始递增，如wz_recomm_detail1， wz_recomm_detail2...）
  RESULT_IPZONE_RECOMMEND_MORE: "click.wxshop.ipzone_result_recommend_more", // 点击结果页泛娱乐推荐查看更多

  RESULT_ANCHOR_FULI: "click.wxshop.zq_result_fuli", //结果页获取主播福利点击
  RESULT_APP_BACK: "click.wxshop.zq_result_back", //结果页返回快手app点击

  ORDER_SELECT_ZONE: "click.wxshop.select_zone", // 订单页点击选择大区
  PRE_ORDER_SELECT_ZONE: "click.wxshop.pre_select_zone", // 订单页点击选择大区

  SERVICEZONE_TAB: "click.wxshop.zq_service_zone_nav", // 专区页导航点击
  SERVICEZONE_HERO_LIST_NEWS: "click.wxshop.zq_service_zone_hero_list_news", // 专区页面英雄皮肤tab下点击资讯
  SERVICEZONE_HOME_NEWS: "click.wxshop.zq_service_zone_home_news", // 专区页首页tab下点击资讯
  SERVICEZONE_ADS_BANNER: "click.wxshop.zq_shelf_banner", // 专区页面点击重磅推荐(不区分内部外部商品)
  // SERVICEZONE_ADS_INNER: "click.wxshop.serviceZone_innerAds", // 专区页面点击重磅推荐(内部商品)
  // SERVICEZONE_ADS_OUTER: "click.wxshop.serviceZone_outerAds", // 专区页面点击重磅推荐(外部商品)
  SERVICEZONE_MORE_INNERTAB: "click.wxshop.zq_serviceZone_more_innertab", // 专区页面点击更多
  SERVICEZONE_MORE_PAY_COIN: "click.wxshop.zq_gmecoin_more", // 展开更多充值档位
  SERVICEZONE_DETAIL_SHARE: "click.wxshop.zq_detail_share",
  SERVICEZONE_DETAIL_ACT_SHARE: "click.wxshop.zq_detail_act_share",
  SERVICEZONE_DETAIL_LIKE: "click.wxshop.zq_detail_like",

  SERVICEZONE_SHELF_GOODS: "click.wxshop.zq_shelf_goods", // 英雄皮肤货架点击(推荐道具)
  SERVICEZONE_SHELF_GOODS_MORE: "click.wxshop.zq_shelf_goods_more", // 英雄皮肤更多
  SERVICEZONE_SHELF_GOODS_REFRESH: "click.wxshop.zq_shelf_goods_refresh", // 英雄皮肤更多

  SERVICEZONE_SHELF_CONTENT: "click.wxshop.zq_shelf_content", // 资讯攻略
  SERVICEZONE_SHELF_CONTENT_MORE: "click.wxshop.zq_shelf_content_more", // 资讯攻略
  SERVICEZONE_SHELF_CONTENT_REFRESH: "click.wxshop.zq_shelf_content_refresh", // 资讯攻略

  SERVICEZONE_SHELF_HERO_LIST_HERO: "click.wxshop.zq_goods", // 全量英雄频道-点击英雄
  SERVICEZONE_SHELF_HERO_DRAWER_GOODS: "click.wxshop.zq_goods_drawer_goods", // 抽屉-商品购买
  SERVICEZONE_SHELF_HERO_DRAWER_REAL_GOODS: "click.wxshop.zq_goods_drawer_real_goods", // 抽屉-商品购买
  SERVICEZONE_SHELF_HERO_DRAWER_NEWS: "click.wxshop.zq_goods_drawer_content", // 抽屉-资讯

  SERVICEZONE_SHELF_DETAIL_CHANGE_ZONE: "click.wxshop.zq_goods_detail_login", //详情页-切换大区
  SERVICEZONE_SHELF_DETAIL_INGAMECOIN_BUY: "click.wxshop.zq_goods_detail_inGameCoin_buy", //详情页-金币支付
  SERVICEZONE_SHELF_DETAIL_BUY: "click.wxshop.zq_goods_detail_buy", //详情页-点券/现金/QB支付
  SERVICEZONE_SHELF_DETAIL_CDKEY_EXCHANGE: "click.wxshop.zq_goods_detail_cdkey_exchange", // 道具详情页-CDKEY兑换
  SERVICEZONE_SHELF_DETAIL_DESC_HERORELATION: "click.wxshop.zq_goods_detail_relation", //详情页-英雄关系
  SERVICEZONE_SHELF_DETAIL_DESC_SKILLDATA: "click.wxshop.zq_goods_detail_skill", //详情页-技能介绍
  SERVICEZONE_SHELF_DETAIL_STRATEGY_CONTENT: "click.wxshop.zq_goods_detail_content", //详情页-相关资讯
  SERVICEZONE_SHELF_DETAIL_STRATEGY_REFRESH: "click.wxshop.zq_goods_detail_refresh", //详情页-相关资讯-换一批
  SERVICEZONE_SHELF_DETAIL_ANCHOR: "click.wxshop.zq_goods_detail_anchor", //详情页-导航栏
  SERVICEZONE_SHELF_DETAIL_RETURNZONEHOME: "click.wxshop.zq_goods_detail_return_zone_home", //详情页-导航栏
  SERVICEZONE_DETAIL_PIC_SHELF: "click.wxshop.zq_goods_detail_pic", //详情页-图片货架
  SERVICEZONE_DETAIL_PIC_SHELF_BANNER: "click.wxshop.zq_goods_detail_banner", //详情页-图片货架-更新后
  SERVICEZONE_DETAIL_ADS: "click.wxshop.zq_goods_detail_ads", //详情页-业务层级广告货架点击
  SERVICEZONE_DETAIL_LINES: "click.wxshop.zq_goods_detail_lines", // 点击播放台词-音频
  SERVICEZONE_DETAIL_BGM: "click.wxshop.zq_goods_detail_bgm", // 点击播放主题曲
  SERVICEZONE_DETAIL_RELATED: "click.wxshop.zq_goods_detail_related", // 点击关联道具
  SERVICEZONE_DETAIL_GUESS_YOU_LIKE: "click.wxshop.zq_goods_detail_recommend", // 点击猜你喜欢
  SERVICEZONE_DETAIL_VIDEO: "click.wxshop.zq_goods_detail_video", // 点击猜你喜欢
  SERVICEZONE_DETAIL_LUCK: "click.wxshop.zq_goods_detail_luck", //结果页获取主播福利点击

  // 详情页好友推荐
  DETAIL_FRIEND_RECOMMEND: "click.wxshop.zq_goods_detail_friend", //商品详情页好友推荐条曝光
  DETAIL_RATE_FRIEND_RECOMMEND_AGREE: "click.wxshop.zq_score_result_friend_agree", //评分后引导弹窗推荐条同意点击
  DETAIL_RATE_FRIEND_RECOMMEND_DISAGREE: "click.wxshop.zq_score_result_friend_disagree", //评分后引导弹窗推荐条不同意点击
  DETAIL_RATE_FRIEND_RECOMMEND_COMMENTS: "click.wxshop.zq_score_result_friend_comments", //评分后引导弹窗种草语录点击
  DETAIL_RATE_FRIEND_RECOMMEND_SUBMIT: "click.wxshop.zq_score_result_friend_submit", //评分后引导弹窗提交按钮点击
  DETAIL_FRIEND_RECOMMEND_DIALOG_CLOSE: "click.wxshop.zq_friend_close", //好友推荐弹窗关闭点击
  DETAIL_FRIEND_RECOMMEND_DIALOG_EDIT: "click.wxshop.zq_friend_position_edit", //好友推荐弹窗修改推荐状态点击
  DETAIL_FRIEND_RECOMMEND_DIALOG_HIDE: "click.wxshop.zq_friend_position_edit_invisible", //好友推荐弹窗修改推荐状态隐藏点击
  DETAIL_FRIEND_RECOMMEND_DIALOG_DELETE: "click.wxshop.zq_friend_position_edit_delete", //好友推荐弹窗修改推荐状态删除点击
  DETAIL_FRIEND_RECOMMEND_DIALOG_SHOW: "click.wxshop.zq_friend_position_edit_visible", //好友推荐弹窗修改推荐状态显示点击

  // 结果页好友推荐
  RESULT_FRIEND_RECOMMEND_STAR: "click.wxshop.zq_recommend_friend_star", //支付结果页好友种草弹窗评星区域点击
  RESULT_FRIEND_RECOMMEND_COMMENTS: "click.wxshop.zq_recommend_friend_comments", //支付结果页好友种草弹窗种草语录点击
  RESULT_FRIEND_RECOMMEND_CHANGE_RATE: "click.wxshop.zq_recommend_friend_change", //支付结果页好友种草弹窗切换点击去评分
  RESULT_FRIEND_RECOMMEND_SUCC_BACK: "click.wxshop.zq_recommend_friend_success_goods", //支付结果页好友种草成功弹窗返回商品详情页点击
  RESULT_FRIEND_RECOMMEND_SUBMIT: "click.wxshop.zq_recommend_friend_submit", //支付结果页好友种草弹窗提交点击
  RESULT_FRIEND_RECOMMEND_RATE_STAR: "click.wxshop.zq_score_friend_star", //支付结果页评分弹窗（种草引导）评星点击
  RESULT_FRIEND_RECOMMEND_CHANGE_RECOMM: "click.wxshop.zq_score_friend_change", //支付结果页评分弹窗（种草引导）切换点击去种草
  RESULT_FRIEND_RECOMMEND_RATE_SUBMIT: "click.wxshop.zq_score_friend_submit", //支付结果页评分弹窗（种草引导）提交点击
  RESULT_FRIEND_RECOMMEND_RATE_SUCC_CLICK: "click.wxshop.zq_score_friend_success_giftcenter", //支付结果页评分弹窗（种草引导）评分成功前往礼包中心点击

  SERVICEZONE_SHELF_NEWS_CONTENT: "click.wxshop.zq_content", //资讯频道点击资讯
  SERVICEZONE_SHELF_NEWS_GOODS: "click.wxshop.zq_content_goods", //资讯频道点击感兴趣道具
  SERVICEZONE_SHELF_NEWS_DETAIL_GOODS: "click.wxshop.zq_content_detail_goods", //资讯详情页-商品购买
  SERVICEZONE_SHELF_NEWS_DETAIL_UP: "click.wxshop.zq_content_detail_up", //资讯详情页-点击赞
  SERVICEZONE_SHELF_NEWS_DETAIL_DOWN: "click.wxshop.zq_content_detail_down", //资讯详情页-点击踩
  SERVICEZONE_SHELF_NEWS_CONTENT_NEWS: "click.wxshop.zq_content_news", //资讯页点击相关资讯
  SERVICEZONE_SHELF_NEWS_CONTENT_MORE: "click.wxshop.zq_content_more", // 资讯攻略页推荐阅读点击更多

  SERVICEZONE_SHELF_RESULT_GOODS: "click.wxshop.zq_result_goods", //结果页点击推荐道具
  SERVICEZONE_SHELF_RESULT_MORE: "click.wxshop.zq_result_more", //结果页点击更多推荐
  SERVICEZONE_SHELF_RESULT_NEWS: "click.wxshop.zq_result_news", //结果页点击推荐资讯
  SERVICEZONE_SHELF_RESULT_NEWS_MORE: "click.wxshop.zq_result_news_more", //结果页点击资讯的更多

  SERVICEZONE_SHELF_RANK: "click.wxshop.zq_shelf_ranking", //一周榜单
  SERVICEZONE_SHELF_RANK_MORE: "click.wxshop.zq_shelf_ranking_more", //一周榜单更多
  SERVICEZONE_SHELF_RANK_GOODS: "click.wxshop.zq_shelf_ranking_goods", //一周榜单具体物品
  SERVICEZONE_SHELF_RANK_REFRESH: "click.wxshop.zq_shelf_ranking_refresh", //一周榜单换一批
  SERVICEZONE_RANK_LIST_RANKITEM: "click.wxshop.zq_ranking", // 榜单列表点击查看排行榜
  SERVICEZONE_RANK_LIST_GOODSITEM: "click.wxshop.zq_ranking_goods", // 榜单列表点击查看英雄
  SERVICEZONE_RANK_DETAIL_GOODS: "click.wxshop.zq_ranking_detail_goods", //榜单详情页点击英雄
  SERVICEZONE_RECOMMEND_GOODS: "click.wxshop.zq_recommend_goods", //推荐频道点击道具
  SERVICEZONE_CLICK_TASK: "click.wxshop.zq_entrance_mission", //专区页点击去任务中心
  SERVICEZONE_CLICK_TAB: "click.wxshop.zq_entrance",
  SERVICEZONE_CLICK_BIRTH: "click.wxshop.zq_entrance_birth", //专区页点击去任务中心
  SERVICEZONE_SHELF_GOODS_HIGHSCORE: "click.wxshop.zq_shelf_goods_highscore", // 高分货架道具点击
  SERVICEZONE_SHELF_HIGHSCORE_SUBTAB: "click.wxshop.zq_highscore_subTab", // 子榜单tab点击
  SERVICEZONE_SHELF_HIGHSCORE_DETAIL: "click.wxshop.zq_highscore_detail", // 子榜单查看点击

  SERVICEZONE_SHELF_ACTIVITY_CARD: "click.wxshop.zq_events", // 活动卡片货架点击
  SERVICEZONE_SHELF_COMMODITY_LIST: "click.wxshop.zq_commodity", // 新版复合商品货架点击
  SERVICEZONE_SHELF_COMMODITY_LIST_TAB: "click.wxshop.zq_service_zone_nav_commodity", // 商品频道-点击导航栏-商品（通过keyName拼接）
  SERVICEZONE_SHELF_COMMODITY_LIST_SECONDARY: "click.wxshop.zq_service_commodity_category", // 商品频道-点击二级货架类目
  SERVICEZONE_SHELF_COMMODITY_LIST_THIRD: "click.wxshop.zq_service_commodity_label", // 商品频道-点击三级标签

  // 清空历史记录
  SERVICEZONE_SEARCH: "click.wxshop.zq_search", // 点击搜索 Icon，入口
  SERVICEZONE_SEARCH_CLOSE: "click.wxshop.zq_search_close", // 点击取消搜索
  SERVICEZONE_CLEAR_HISTORY_SEARCH: "click.wxshop.zq_clear_history_search", // 点击清除历史记录
  SERVICEZONE_SUBMIR_SEARCH_CONTENT: "click.wxshop.zq_search_input",
  SERVICEZONE_SEARCH_DAOJU_RESULT: "click.wxshop.zq_search_daoju_result", // 点击搜索结果
  SERVICEZONE_SEARCH_NEWS_RESULT: "click.wxshop.zq_search_news_result", // 点击搜索结果

  SERVICEZONE_GOODS_LIST: "click.wxshop.zq_goods_list", //通用专区全部道具频道点击道具
  SERVICEZONE_HOT_GOODS_LIST: "click.wxshop.zq_hot_goods", //通用专区热门货架点击道具
  SERVICEZONE_NEW_GOODS_LIST: "click.wxshop.zq_new_goods", //通用专区新品货架点击道具
  SERVICEZONE_SHELF_SWITCH_CLASSIFY: "click.wxshop.zq_secondtab", //分类货架点击分类切换

  // 预售
  PRE_ORDER_RECHARGE: "click.wxshop.zq_pre_coin",
  PRE_ORDER_EXCHANGE: "click.wxshop.zq_pre_get",
  PRE_ORDER_EXCHANGE_SELECT: "click.wxshop.zq_pre_exchange_select",
  PRE_ORDER_EXCHANGE_SELECT_ALL: "click.wxshop.zq_pre_exchange_select_all",

  // 兑换
  PRE_ORDER_EXCHANGE_DAOJU_COMMIT: "click.wxshop.dj_exchange", // 兑换预售的道具
  PRE_ORDER_EXCHANGED_DAOJU_COMMIT: "click.wxshop.dj_exchanged", // 预售的道具已兑换重新点击
  PRE_ORDER_EXCHANGE_DAOJU_ERROR: "click.wxshop.dj_wrongexchanged", // 兑换道具报错

  // 影音专区
  IPZONE_CLICK_BUY: "click.wxshop.ipzone_listitem", // 专区页面点击商品跳转到订单页 拼接：_{index}_{groupId}
  IPZONE_CLICK_ACTIVITY: "click.wxshop.ipzone_ad", // 专区页面点击活动跳转到活动详情 拼接：_{index}_{groupId}
  IPZONE_CLICK_HOT_MORE: "click.wxshop.ipzone_hotmore", // 专区页面点击更多热门单品 拼接：_{groupId}
  IPZONE_CLICK_HOT: "click.wxshop.ipzone_hot", // 专区页面点击热门单品跳转到详情 拼接：_{index}_{groupId}

  //小专区
  ZONE_CLICK_BUY: "click.wxshop.zone_button", //小专区模块点击去专区按钮
  ZONE_CLICK_SUBSCRIBE: "click.wxshop.zone_subscribe", //小专区模块点击订阅
  ZONE_CLICK_BANNER: "click.wxshop.zone_banner", //小专区模块点击banner
  ZONE_CLICK_GOODS: "click.wxshop.zone_goods", //小专区模块点击商品坑位
  ZONE_CLICK_MORE: "click.wxshop.zone_more", //小专区模块点击更多

  // 会员钻列表页影音专区
  VIPLIST_IPZONE_CLICK_BUY: "click.wxshop.vipipzone_open", // 会员钻列表页专区页面点击商品(跳转到订单页) 拼接：_{index}_{groupId}
  VIPLIST_IPZONE_CLICK_ACTIVITY: "click.wxshop.vipipzone_ad", // 会员钻列表页专区页面点击活动(跳转到活动详情) 拼接：_{index}_{groupId}
  VIPLIST_IPZONE_CLICK_HOT_MORE: "click.wxshop.vipipzone_hotmore", // 会员钻列表页专区页面点击更多推荐 拼接：_{groupId}
  VIPLIST_IPZONE_CLICK_HOT: "click.wxshop.vipipzone_hot", // 会员钻列表页专区页面点击推荐单品(跳转到详情) 拼接：_{index}_{groupId}

  // 月卡开通页曝光
  GAME_MONTHCARD_RECHARGE: "click.wxshop.game_monthcard_recharge", // 游戏月卡开通点击，后面接月卡id _{productid}
  GAME_MONTHCARD_DETAIN: "click.wxshop.game_monthcard_detain", // 挽留弹窗出来后，用户点击了继续按月开通还是连续包月 _{}后面跟continuousMonth或者是month${openMonth}

  GAME_MONTHCARD_TODETAIL: "click.wxshop.game_monthcard_todetail", // 点击月卡进入月卡详情页
  GAME_MONTHCARD_DETAIL_RETURNZONEHOME: "click.wxshop.game_monthcard_return_zone_home", // 月卡详情页点击回到专区主页按钮

  IPZONE_CLICK_TIPSPLACEHOLDER: "click.wxshop.ipzone_tipsPlaceholder", //专区点击底部浮层

  // 统一错误页
  ERROR_RETURN_INDEX: "click.wxshop.errorpage_homepage", // 统一错误页点击返回首页
  CLICK_PREFIX: "click.wxshop.",

  RESERVATION_CAROUSEL_ITEM_CLICK: "click.wxshop.zq_reservation_carousel", // 预约页面点击轮播图
  RESERVATION_PROP_LIST_ITEM_CLICK: "click.wxshop.zq_reservation_propList", // 预约页面点击轮播图
  RESERVATION_CLICK: "click.wxshop.zq_reservation_click", // 预约页面点击轮播图

  SERVICE_ZONE_POP_CLICK: "click.wxshop.zq_pop_receive_click", // 专区首页拍脸弹窗报错

  // 任务中心
  TASK_CLICK_GET_PRESENT: "click.wxshop.zq_mission_get", // 任务模式点击领取奖品
  TASK_CLICK_GO_FINISH: "click.wxshop.zq_mission_go", // 任务模式点击去完成

  POP_DIALOG: "click.wxshop.pop_dialog", // 拍脸弹
  PENDANT: "click.wxshop.pendant", // 挂件,

  // 广场
  MALL_POSITION: "click.wxshop.mall_position", // 集市广场点击
  MALL_TAB_CHANGE: "click.wxshop.mall_tab", // tab 切换的点击 shop/goods
  MALLSHOP_MORE_BUSINESS: "click.wxshop.mallshop_more", //好店底部查看更多业务
  MALL_SHORT_VIDEO_SLIDE: "click.wxshop.content_slide", // 视频向下滑动时的上报
  MALL_CONTENT_RELATED_GOODS: "click.wxshop.content_related_goods", // 内容详情页推荐内容点击商品
  MALL_CONTENT_RELATED_OPSITON: "click.wxshop.content_related_opsiton", // 内容详情页推荐内容点击专区
  MALL_VIDEO_SHARE: "click.wxshop.content_share", // 广场视频分享
  MALL_VIDEO_LIKE: "click.wxshop.content_like", // 广场视频点赞
  MALL_VIDEO_DISLIKE: "click.wxshop.content_dislike", // 广场视频取消点赞
  MALL_READ_TASK_CLOSE: "click.wxshop.mall_floating_close",
  MALL_READ_TASK_CLICK: "click.wxshop.mall_floating",
  MALL_READ_TASK_COMPLETE_CLICK: "click.wxshop.mall_floating_finish",

  // 新游预约集合页
  RESERVATION_LIST_ADS_BANNER: "click.wxshop.reservation_collectionpage_banner",
  RESERVATION_LIST_ADS_TIMELINE: "click.wxshop.reservation_collectionpage_timeline",
  RESERVATION_LIST_TO_ZONE: "click.wxshop.reservation_collectionpage_zq",

  //游戏列表页
  GAME_ZONE_LIST_ADS_BANNER: "click.wxshop.gamepage_banner", // 广告位
  GAME_ZONE_LIST_HOT_ALL: "click.wxshop.gamepage_hot_all", // 热门游戏-全部
  GAME_ZONE_LIST_HOT_CARD: "click.wxshop.gamepage_hot", // 热门游戏-各个卡片
  GAME_ZONE_LIST_MINE_ALL: "click.wxshop.gamepage_mine_all", // 我的游戏-全部
  GAME_ZONE_LIST_RESERVATION_ALL: "click.wxshop.gamepage_reservation_all", // 新游预约-全部
  GAME_ZONE_LIST_RESERVATION_CARD: "click.wxshop.gamepage_reservation", // 新游预约-各个卡片
  GAME_ZONE_LIST_RECOMMEND_ALL: "click.wxshop.gamepage_recommend_all", // 推荐你玩-全部
  GAME_ZONE_LIST_RECOMMEND_CARD: "click.wxshop.gamepage_recommend", // 推荐你玩-各个卡片

  // 直播购相关
  LIVE_PRODUCT_USING_CLICK: "click.wxshop.liveroom_using",
  LIVE_PRODUCT_RECOMMEND_CLICK: "click.wxshop.liveroom_recommend",
  LIVE_SQUERE_CLICK: "click.wxshop.liveroom_square",
  LIVE_REMINDER: "click.wxshop.liveroom_reminder",
  LIVE_RECOMMEND_MORE: "click.wxshop.liveroom_recommend_more",

  // 道具通兑券
  REDEEM_PICK_CLICK: "click.wxshop_exchange.pickon",
  REDEEM_DIALOG_CLICK: "click.wxshop_exchange.confirm",
  REDEEM_ICON_POST_OFFICE: "click.wxshop_exchange.post_office_exchange",

  // 快手
  //click.wxshop.zq_account_qq click.wxshop.zq_account_wx
  DETAIL_OUTER_CHANGE_ACCOUNT: "click.wxshop.zq_account", // 道具详情页切换账号qq/wx按钮点击
  DETAIL_OUTER_NAV_QA: "click.wxshop.zq_result_QA", // 外部带货头部的qa 按钮点击
  DETAIL_OUTER_NAV_ZONE: "click.wxshop.zq_goods_detail_jump_qshop", // 外部头部导航的前往专区 按钮点击

  // 观影券页面
  IPZONE_GOODS_BUY: "click.wxshop.txspipzone_coupon_detail_buy", //（resultinfo里传：券类型 and 券id） 点播券页面立即购买点击(观影券的会员购买)
  IPZONE_GOODS_NOVIP_BUY: "click.wxshop.txspipzone_coupon_film_notvipbuy", //观影券页面非会员购买点击
  IPZONE_GOODS_NOVIP_TIP_CONFIRM: "click.wxshop.txspipzone_coupon_detail_popups", //点播券页面-非会员购买提示去专区点击
  IPZONE_GOODS_NOVIP_TIP_CANCLE: "click.wxshop.txspipzone_coupon_detail_popups_close", //点播券页面-非会员购买提示取消点击
  IPZONE_GOODS_VIP_TIP_BUY: "click.wxshop.txspipzone_coupon_film_popups_vip_buy", //观影券页面会员按非会员价购买弹窗里点击购买

  // 发电榜
  IPZONE_CHARTS_NAV: "click.wxshop.txspipzone_charts_nav", //发电榜tab
  IPZONE_CHARTS_LIGHT: "click.wxshop.txspipzone_charts_light", //发电榜tab

  // 二楼
  SECOND_FLOOR_GUIDE_CLICK: "click.wxshop.homepage_banner_entrance", // 二楼引导入口点击
  SECOND_FLOOR_GUIDE_PULL: "click.wxshop.homepage_banner_slide", // 二楼引导入口下拉
  SECOND_FLOOR_ADS_CLICK: "click.wxshop.banner_head", // resultinfo传位置和素材id

  // 头部积分
  HEADER_USER_JIFEN: "click.wxshop.perosonal_jfshop", // 新增

  // 评分
  DETAIL_STAR_GO_TO_RATE: "click.wxshop.zq_detail_score", // 专区货架内去评分点击
  DETAIL_GOODS_BANNER_RATE: "click.wxshop.zq_goods_detail_score", // 专区道具头图点击去评分
  FISSION_LIST_PAGE_DIALOG: "click.wxshop.zq_goods_detail_gofissionlistpage_", // 跳转到裂变集合分享页面
  DETAIL_GOODS_RATE_AUTO: "click.wxshop.zq_goods_detail_score_auto", // 自动帮用户拉起弹窗或者默认iformat
  DETAIL_RESULT_POP_BACK: "click.wxshop.zq_score_result_pop_back", // 评分后引导弹窗返回点击
  DETAIL_RESULT_POP_GIFTCENTER: "click.wxshop.zq_score_result_pop_giftcenter", // 评分后引导弹窗前往礼包中心点击
  DETAIL_RESULT_POP_MORE: "click.wxshop.zq_score_result_pop_more", // 评分弹窗点击去更多商品

  RESERVATION_STAR_GO_TO_RATE: "click.wxshop.zq_reservation_score", // 预约页面点击去评分
  RESERVATION_STAR_GO_TO_MY_RATE: "click.wxshop.zq_reservation_myscore", // 预约页面点击我的评分

  // 通用评分
  RATE_CLICK_STAR: "click.wxshop.zq_star_score_pop_star", // 专区道具评分弹窗点击星星
  RATE_SUBMIT_STAR: "click.wxshop.zq_star_score_pop_submit", // 专区道具评分弹窗点击提交

  // 团购相关
  DETAIL_TEAM_BUY: "click.wxshop.zq_goods_detail_buy_discount", //开团按钮
  DETAIL_TEAM_REMIND: "click.wxshop.zq_goods_detail_remind", //点击提醒
  DETAIL_TEAM_RULE_CLOSE: "click.wxshop.zq_act_team_popup_rule_close", //点击关闭活动规则
  DETAIL_TEAM_GOTOJOIN_NULL: "click.wxshop.zq_act_team_homepage_before_null", //（参团前-自己进入）点击立即参与（没有其他人团时的查看全部团点击）
  DETAIL_TEAM_GOTOJOIN_ONE: "click.wxshop.zq_act_team_homepage_before_join", //（参团前-自己进入）点击去参团（页面上的其他人团里的去参团）
  DETAIL_TEAM_GOTOJOIN_ALL: "click.wxshop.zq_act_team_homepage_before_others", //（参团前-自己进入）点击查看全部的团
  DETAIL_TEAM_JOIN_BUY: "click.wxshop.zq_act_team_homepage_join_confirm", //（分享/参与别人团）点击加入该团
  DETAIL_TEAM_GOTOJOIN_OTHER: "click.wxshop.zq_act_team_homepage_join_others", //（分享/参与别人团）点击查看其它团
  DETAIL_TEAM_ENTRYGAME: "click.wxshop.zq_act_team_homepage_self_entry", //只能看到自己团）-- 点击进入游戏
  DETAIL_TEAM_INVITE: "click.wxshop.zq_act_team_homepage_self_invite", //（只能看到自己团）-- 点击邀请好友
  DETAIL_TEAM_PAYSUCC_INVITE: "click.wxshop.zq_act_team_popup_paysuccess_invite", //支付成功弹窗-邀请好友开团
  DETAIL_TEAM_PAYSUCC_CLOSE: "click.wxshop.zq_act_team_popup_paysuccess_cancel", //支付成功弹窗-取消（包括左上角关闭）
  DETAIL_TEAM_SHARE_CLOSE: "click.wxshop.zq_act_team_popup_share_close", //活动支付成功分享卡-点击关闭
  DETAIL_TEAM_LIST_GOTOJOIN_ONE: "click.wxshop.zq_act_team_popup_list_join", //活动陌生人团页-点击去参团（拉起的团列表页）
  DETAIL_TEAM_LIST_GOTOJOIN_REFRESH: "click.wxshop.zq_act_team_popup_list_change", //活动陌生人团页-点击换一批（拉起的团列表页）
  DETAIL_TEAM_TIPS_POPUP_SUBSCRIBE: "click.wxshop.zq_act_team_popup_subscribe_open", //订阅弹窗订阅的点击
  DETAIL_TEAM_TIPS_POPUP_CANCEL: "click.wxshop.zq_act_team_popup_subscribe_close", //订阅弹窗退订的点击

  // 详情页索要
  DETAIL_DEMAND: "click.wxshop.zq_goods_detail_askfor",
  DETAIL_DEMAND_ACTION: "click.wxshop.zq_goods_detail_askfor_action",

  // 详情页赠送
  DETAIL_SEND_BTN: "click.wxshop.zq_goods_detail_buy_gift", //详情页-赠送给好友-按钮点击
  DETAIL_FRIEND_POPUP_SEND: "click.wxshop.zq_goods_selectfriend_popups_confirm", //好友弹窗里赠送支付按钮-点击

  // 优惠券
  DETAIL_COUPON: "click.wxshop.zq_goods_detail_coupon", //商品详情页-选择抵扣券点击

  // 个人中心权益
  APPLESTORE_RIGHTS_INTERESTS_CLICK: "click.wxshop.personal_applestore", // apple store权益点击
  QB_RIGHTS_INTERESTS_CLICK: "click.wxshop.personal_qb", // qb权益点击

  // iOS充值Tab相关
  APPLE_STORE_TAB: "click.wxshop.homepage_applestore_tab",
  QB_TAB: "click.wxshop.homepage_qb_tab",

  // 订单中心相关
  ORDERS_ENTRANCE_KS_CLICK: "click.wxshop.zq_orders_entrance", // 订单中心入口点击上报（专区内）本次为应用在快手分店内
  ORDERS_ENTRANCE_STORE_CLICK: "click.wxshop.homepage_orders_entrance", // 订单中心入口点击上报（商店首页内），当前暂无，日后商店内上了订单中心可能会增加。

  // 背包相关
  BACKPACK_POSITION: "click.wxshop.zq_backpack_position", // 背包相关的位置
  BACKPACK_FILTER: "click.wxshop.zq_backpack_filter", // 筛选器的点击
  BACKPACK_SHARE: "click.wxshop.zq_backpack_share", // 背包分享的点击
  BACKPACK_DETAIL_MYSCORE: "click.wxshop.zq_backpack_detail_myscore", // 我的评分点击
  BACKPACK_DETAIL_BACK: "click.wxshop.zq_backpack_detail_back", // 背包返回的点击
  BACKPACK_DETAIL_FEATURE: "click.wxshop.zq_backpack_detail_features", // 背包详情底部按钮
  BACKPACK_DETAIL_ZONE: "click.wxshop.zq_backpack_detail_login", // 背包详情页大区组件点击
  BACKPACK_FILTER_CONDITION: "click.wxshop.zq_backpack_filter_popup_conditions", // 筛选器条件点击
  BACKPACK_FILTER_CONFIRM: "click.wxshop.zq_backpack_filter_popup_confirm", // 确认筛选按钮点击
  BACKPACK_FILTER_RESET: "click.wxshop.zq_backpack_filter_popup_reset", // 重置按钮点击
  BACKPACK_NAV_ENTER: "click.wxshop.zq_account_backpack", // 专区首页背包入口点击
  BACKPACK_INVENTORY_ENTER: "click.wxshop.zq_backpack_series", // 背包盘点系列入口
  BACKPACK_INVENTORY_LIST_ITEM: "click.wxshop.zq_backpack_collection_position", // 单个系列入口点击
  BACKPACK_INVENTORY_GOODS: "click.wxshop.zq_backpack_singleseries_position", // 单个商品详情页入口点击
  BACKPACK_INVENTORY_SHARE: "click.wxshop.zq_backpack_singleseries_share", // 背包盘点页面的分享
  BACKPACK_INVENTORY_BUY: "click.wxshop.zq_backpack_singleseries_buy", // 背包盘点页购买按钮
  BACKPACK_NEW_YEAR_PREVIEW: "click.act_cover.homepage_preview", // 红包封面预览
  BACKPACK_NEW_YEAR_RULE: "click.act_cover.homepage_rule", // 活动规则按钮点击
  BACKPACK_NEW_YEAR_RECEIVE: "click.wxshop.zq_backpack_singleseries_receive", // 红包领取按钮点击

  // 授权
  AUTH_ENTRY: "click.wxshop.zq_account_authorize", //专区首页授权入口点击
  AUTH_MANAGE_CONFIRM: "click.wxshop.zq_authorize_open", //专区授权管理页面开关打开
  AUTH_MANAGE_CANCEL: "click.wxshop.zq_authorize_close" //专区授权管理页面开关关闭
}

export const ERROR = {
  SHOP_GET_OPENLINK: "error.wxshop.get_openlink_error",
  // 详情页面参数错误
  DETAIL_PAGE_ERROR: "error.wxshop.detail_pageerror",
  PREORDER_PAGE_GROUPID_ERROR: "error.wxshop.preorder_groupiderror",
  PREORDER_PAGE_LACK_GROUPID: "error.wxshop.preorder_groupidlack",
  // 获取QQ昵称报错
  NICK_GET_ERROR: "error.wxshop.zq_goods_userNick_error",
  // 获取QQ互联昵称报错
  QQCONNECTNICK_GET_ERROR: "error.wxshop.zq_goods_qcUserNick_error",
  // 获取QQ互联登录态getMe方法报错
  QQCONNECT_GETME_GET_ERROR: "error.wxshop.user_qcGetMe_error",
  // wxconfig报错
  WXCONFIG_GET_ERROR: "error.wxconfig.getJssdk_error",
  WXCONFIG_SET_ERROR: "error.wxconfig.setWxconfig_error",
  GREDEEM_CONFIG: "error.gredeemcoupon_config",
  // 页匠跳转报错
  PAGEDOO_REDIRECT: "error.pagedd_redidect"
}

// 数据分析上报
export const ANALYSE = {
  // 手游大区缓存读数据
  MOBILE_STORAGE: "report.select.mobile.storage",
  // 手游大区从推荐读取
  MOBILE_ZONE_RECOMMEND: "report.wxshop.mobile.zone.recommend",
  // 手游大区从默认大区读取
  MOBILE_ZONE_DEFAULT: "report.wxshop.mobile.zone.default",
  // 调用 getZoneInfo 的上报
  GET_ZONE_INFO_REPORT: "report.wxshop.zone.get_zone_info",
  // 调用 getZoneInfo 中间的上报
  GET_ZONE_INFO_REPORT_2: "report.wxshop.zone.get_zone_info_2",
  // 调用 getZoneInfo 的结果
  GET_ZONE_INFO_OLD_RESULT: "report.wxshop.zone.get_old_zone_info_result",
  // 调用新大区组件的结果
  GET_ZONE_INFO_NEW_RESULT: "report.wxshop.zone.get_new_zone_info_result",
  GET_INDEX_DEFAULT_UIN_ERROR_RESULT: "report.wxshop.zone.get_index_default_uin_error_result",
  // 端游从缓存大区读数据
  PC_STORAGE: "report.select.pc.storage",
  // 王者荣耀灰度
  ORDER_WZRY_DAOJU: "report.wxshop.order_wzry_daoju",
  // 传递手游取点券offerid的结果
  MOBILE_GAMECOIN_OFFERID: "report.wxshop.order_gamecoin_offerid",
  // 用户命中 page cache 重载的上报
  PAGE_CACHE_REFRESH: "report.wxshop.page_cache",
  // 用户命中登录态失败的上报
  PAGE_LOGIN_ERROR: "report.wxshop.game_login_error",
  SERVICEZONE_REDIRECT_CARD_ERROR: "report.wxshop.servicezone_redirect_error",
  // ab实验异常分析
  TAB_AB_ERROR: "report.wxshop.tab_ab",
  QQ_TEENAGER: "report.wxshop.qq_teenager",

  //点击购买，带上物品信息，为了后续分析预售时有用户没有携带contains_exchange_coupon
  DETAIL_BUY: "report.wxshop.goods_detail_buy",
  BEFORE_ACTIVITY_PROC: "report.wxshop.goods_detail_before_activity_proc",

  ACTIVITY_PROC: "report.wxshop.goods_detail_activity_proc",
  ACTIVITY_PROC_CATCH: "report.wxshop.goods_detail_activity_proc_catch",
  TEAM_PROC: "report.wxshop.goods_detail_team_proc",
  TEAM_CONFIRM: "report.wxshop.goods_detail_team_confirm",
  // 小程序点券充值，带上pf_header,用于分析source 数据统计
  MINIPROGRAM_DQCZ: "report.wxshop.miniprogram_dqcz"
}

export const NAN_JI = {
  PAY_CLICK: "plus_charge_to_pay_click",
  PAY_SUCCESS: "plus_charge_pay_success_enter",
  PAY_FAIL: "plus_charge_pay_fail_enter"
}

export const SCAN = {
  SERVICEZONE_INDEX: "scan.wxshop.zq_homepage",
  SERVICEZONE_GAMECOIN: "scan.wxshop.zq_gamecoin",
  SERVICEZONE_RECOMMEND: "scan.wxshop.zq_recommend",
  SERVICEZONE_GOODS: "scan.wxshop.zq_goods",
  SERVICEZONE_GOODS_DRAWER: "scan.wxshop.zq_goods_drawer",
  SERVICEZONE_NEWS: "scan.wxshop.zq_content",
  SERVICEZONE_RANKLIST: "scan.wxshop.zq_rank_list",
  SERVICEZONE_NEWS_DETAIL: "scan.wxshop.zq_content_detail",
  SERVICEZONE_GOODS_DETAIL: "scan.wxshop.zq_goods_detail",
  SERVICEZONE_RANK_DETAIL: "scan.wxshop.zq_ranking_detail",
  ZQ_RESULT_PAGE: "scan.wxshop.zq_result",
  SERVICEZONE_CUSTOM: "scan.wxshop.zq_custom",
  PENDANT: "scan.wxshop.pendant",
  MALL: "scan.wxshop.mall",
  MALLSHOP: "scan.wxshop.mallshop",
  MALL_POSITION: "scan.wxshop.mall_position",
  INDEX_ROUTE: "scan.wxshop.homepage",
  CONTENT_DETAIL: "scan.wxshop.content",
  //详情页-头图视频播放时长
  SERVICEZONE_GOODS_DETAIL_VIDEO: "scan.wxshop.zq_goods_detail_video",
  LIVE_DETAIL_SHOW: "scan.wxshop.liveroom",
  RESERVATION_INDEX: "scan.wxshop.reservation",
  STAR: "scan.wxshop.zq_score_view"
}

export const BIGR = {
  //大R曝光
  HOME_PAGE: "pageview.wxshop.bigr_servicezone",
  DETAIL_PAGE: "pageview.wxshop.bigr_servicezone_detail",
  BUYGOODS: "click.wxhop.bigr_buygoods",
  //获取大R信息
  GET_BIGR_USER_ZONES: "pageview.wxhsop.getbigRuserZones",
  //获取大R身份失败
  GET_BIGR_USER_FAILED: "pageview.wxshop.getbigRuser_failed"
}

export const SHOPPING_CART = {
  //购物车取数据异常
  DETAIL_ERROR: "pageview.wxshop.zq_cart.init.error",

  //购物车详情页
  DETAIL_PAGE: "pageview.wxshop.zq_cart",
  //购物车内空页面
  EMPTY_CART: "pageview.wxshop.zq_cart_empty",
  //购物车报错-提醒过滤背包等
  FILTER_BAG: "pageview.wxshop.zq_cart_intercept",

  //点击

  // 详情页-点击加入购物车
  ADD_CART: "click.wxshop.zq_goods_detail_add",
  // 详情页-加入购物车成功
  ADD_CART_SUCCESS: "click.wxshop.zq_goods_detail_add_success",
  // 详情页-点击购物车入口icon
  ENTER_CART: "click.wxshop.zq_cart_enter",

  // 购物车页面-点击支付
  PAY: "click.wxshop.zq_cart_pay",
  PAY_ERROR: "pageview.wxshop.zq_cart_pay.error",
  // 购物车页面-查看优惠明细
  DISCOUNT_DETAIL: "click.wxshop.zq_cart_detail",

  //购物车页面-点击删除物品
  DELETE_PROMPT: "click.wxshop.zq_cart_delete",
  //购物车页面-确认删除物品
  CONFIRM_DELETE: "click.wxshop.zq_cart_delete_confirm",
  DELETE_ERROR: "click.wxshop.zq_cart_delete_erro",
  //购物车页面-点击查看券信息
  CHECK_COUPON_INFO: "click.wxshop.zq_cart_coupon"
}

export const GAME_RECEIVE = {
  PAGE_VIEW: {
    SKIN_CARD: "pageview.wxshop.skincard"
  },
  CLICK: {
    RECEIVE: "click.wxshop.skincard_receive",
    TO_SEND: "click.wxshop.skincard_gift",
    REMAIN_FRIEND: "click.wxshop.skincard_remind"
  },
  ERR: {
    SKIN_CARD: "pageview.wxshop.skincard_fail"
  }
}

export const PROTOCOL = {
  // 支付页-点击用户协议(在结果页进行上报)
  CLICK_PROTOCOL: "click.wxshop.pay_protocol"
}

export const SUCC = {
  RESULT_WITH_DRMCOUPON: "success.wxshop.resultWithDrmCoupon", //支付结果页带drm券
  RESULT_WITH_GAMECOUPON: "success.wxshop.resultWithGameCoupon" //支付结果页带王者券
}

export const SPECIFIC_DISCOUNT_CARD = {
  PAGE_VIEW: {
    GET_CARD_COUPON_STATUS: "pageview.wxshop.60card.status",
    GET_CARD_COUPON_STATUS_SUC: "pageview.wxshop.60card.status.suc",
    GET_COUPON_SUC: "pageview.wxshop.get_specific_discount_card_coupon.suc",
    card60PayPrompt: "pageview.wxshop.60card_pay_popups"
  },
  CLICK: {
    GET_COUPON: "click.wxshop.get_specific_discount_card_coupon",
    INGAME_BUY_CARD: "click.wxshop.60card_pay_popups"
  },
  ERROR: {
    GET_CARD_COUPON_STATUS: "pageview.wxshop.60card.status.error",
    GET_COUPON: "pageview.wxshop.get_specific_discount_card_coupon.error"
  }
}

export const GIFT_TASK = {
  PAGE_VIEW: {
    GET_COUPON_SUC: "pageview.wxshop.get_taskcoupon_suc"
  },
  CLICK: {
    //任务券领券入口点击（=点击后成功弹出券列表弹窗）
    SHOW_TASK_DIALOG: "click.wxshop.zq_goods_detail_taskcoupon",
    GET_COUPON: "click.wxshop.get_taskcoupon"
  },
  ERROR: {
    GET_COUPON: "pageview.wxshop.get_taskcoupon_error"
  }
}
